import React, {Component} from 'react';

import styled from "styled-components";


import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {faSpinner} from '@fortawesome/fontawesome-free-solid'

class LoadingLayer extends Component {
  render() {
    const {className} = this.props;
    return <div className={className}>
      <div className="bg">
        <div className="spinner__container">
          <FontAwesomeIcon icon={faSpinner} size={'2x'} color={'black'} spin={true}/>
        </div>
      </div>
    </div>
  }
}

export default styled(LoadingLayer)`
.bg {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      z-index: 0;
    }
.spinner__container {
  padding: 12px;
  opacity: 0.5;
}
`


// WEBPACK FOOTER //
// ./src/components/LoadingLayer.js